<template>
  <div class="container">
    <header>
      <!-- <img src="/msd.png" alt="MSDevelopment Logo" class="logo"> -->
      <h1>MSDevelopment</h1>
      <p class="subtitle">Holding Company</p>
    </header>

    <main>
      <p class="intro">
        Contact one of the MSDevelopment companies below for innovative digital solutions.
      </p>

      <div class="companies-grid">
        <a href="https://touchtribe.nl" target="_blank" rel="noopener noreferrer" class="company-card">
          <div class="company-name">TouchTribe</div>
          <div class="company-domain">touchtribe.nl</div>
          <div class="company-specialties">Composable Commerce • Headless CMS • Cloud Native</div>
        </a>
        
        <a href="https://elements.nl" target="_blank" rel="noopener noreferrer" class="company-card">
          <div class="company-name">Elements</div>
          <div class="company-domain">elements.nl</div>
          <div class="company-specialties">Mobile & Web Apps • React Native • UX</div>
        </a>
        
        <a href="https://stutit.nl" target="_blank" rel="noopener noreferrer" class="company-card">
          <div class="company-name">StutIT</div>
          <div class="company-domain">stutit.nl</div>
          <div class="company-specialties">Workplace Management • IT Support</div>
        </a>
      </div>

      <p class="network-info">
        MSDevelopment is part of the <a href="https://makerstreet.nl" target="_blank" rel="noopener noreferrer">Makerstreet</a> network.
      </p>

      <footer>
        <p>&copy; {{ new Date().getFullYear() }} MSDevelopment. All rights reserved.</p>
      </footer>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
  background: linear-gradient(135deg, #ffffff 0%, #e8e8e8 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

#app {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  max-width: 1200px;
  width: 100%;
  padding: 40px 20px;
  text-align: center;
}

.logo {
  width: 120px;
  height: auto;
  margin-bottom: 20px;
}

header h1 {
  font-size: 3.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #00deca 0%, #3637df 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  margin-bottom: 10px;
  letter-spacing: -1px;
}

.subtitle {
  font-size: 1.25rem;
  color: #666666;
  font-weight: 300;
  margin-bottom: 60px;
}

.intro {
  font-size: 1.1rem;
  color: #555555;
  margin-bottom: 60px;
  font-weight: 400;
}

.companies-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-bottom: 60px;
}

.company-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 40px 30px;
  text-decoration: none;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.company-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);
  background: #ffffff;
  border-color: rgba(102, 126, 234, 0.2);
}

.company-name {
  font-size: 1.75rem;
  font-weight: 600;
  color: #667eea;
  margin-bottom: 8px;
}

.company-domain {
  font-size: 1rem;
  color: #666;
  font-weight: 400;
  margin-bottom: 12px;
}

.company-specialties {
  font-size: 0.9rem;
  color: #888;
  font-weight: 400;
  margin-top: 12px;
  line-height: 1.4;
}

.network-info {
  font-size: 1rem;
  color: #666666;
  margin: 40px 0;
  font-weight: 400;
}

.network-info a {
  color: #667eea;
  text-decoration: underline;
  transition: opacity 0.2s ease;
}

.network-info a:hover {
  opacity: 0.8;
}

footer {
  margin-top: 40px;
  color: #888888;
  font-size: 0.95rem;
}

@media (max-width: 768px) {
  .logo {
    width: 80px;
  }
  
  header h1 {
    font-size: 2.5rem;
  }
  
  .subtitle {
    font-size: 1rem;
  }
  
  .companies-grid {
    grid-template-columns: 1fr;
  }
  
  .company-card {
    padding: 30px 25px;
  }
}
</style>
